<template>
  <div class="filePage" v-if="files.length != 0 || editType">
    <p class="fgx"></p>
    <van-cell-group class="baseNone baseSalary accessoryBox">
      <p class="tit">
        附件
        <a
          href="javascript:void(0);"
          class="recordImg"
          v-if="editType"
          @click="uploadFile"
          >上传附件</a
        >
      </p>
      <!-- <p v-if="files.length == 0" class="noneFile">暂无附件</p> -->
      <div class="detailMian">
        <ul v-if="files.length > 0">
          <li class="clearfix" v-for="(item, index) in files" :key="index">
            <dl class="fl" @click="preview(item)">
              <dt @click="Showswiper(index)">
                <img
                  :src="
                    getFormat(item.fileName) == 'jpg' ||
                    getFormat(item.fileName) == 'png' ||
                    getFormat(item.fileName) == 'jpeg'
                      ? item.url
                      : getFormat(item.fileName) == 'pdf'
                      ? '' + baseUrl + 'searchImg/pdf.png'
                      : getFormat(item.fileName) == 'xlsx' ||
                        getFormat(item.fileName) == 'xls'
                      ? '' + baseUrl + 'searchImg/excel.png'
                      : '' + baseUrl + 'searchImg/word.png'
                  "
                  alt
                />
              </dt>
              <dd class="dtName">{{ item.fileName }}</dd>
              <dd class="Mb">
                <span>{{ getMb(item.fileSize) }}</span>
              </dd>
            </dl>
            <a
              href="javascript:void(0);"
              class="downloadBtn fr"
              v-if="!baseType || !userAgentType"
              @click="downLoad(item)"
              >下载</a
            >
            <a
              href="javascript:void(0);"
              class="downloadBtn delBtn fr"
              v-if="editType && baseType  && userAgentType"
              @click="delFile(item, index)"
              >删除</a
            >
          </li>
        </ul>
      </div>
    </van-cell-group>
  </div>
</template>
<script>
/* eslint-disable */
import { getDeviceType, is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "fileView",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      files: [],
      commonType: "",
      baseType: false,
      is_weixn: is_wei(), //是否为微信

      userAgentType: "",
      clientType: getDeviceType(), //手机类型
    };
  },

  props: {
    filesData: {
      type: Object,
      default() {
        {
        }
      },
    },
    editType: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    let userAgent = window.navigator.userAgent.toLowerCase();
    window.setFile = this.setFiles; //app返回附件回调
    this.userAgentType = userAgent.indexOf("dhoa") != -1 ? true : false;
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.$nextTick(() => {
      if (this.filesData && this.filesData.files) {
        this.files = this.filesData.baseAnnexes;
        this.baseType =
          this.filesData.verifyStatus == "hold" ||
          this.filesData.verifyStatus == "deny"
            ? true
            : false;
      }
    });
  },
  methods: {
    delFile(item, index) {
      //删除附件
      this.files.splice(index, 1);
      this.$emit("changeFile", this.files);
    },
    //获取文件后缀名
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    getMb(Kb) {
      //计算附件大小
      let size = "";
      size = (Kb / 1024).toFixed(2) + "kB";
      return size;
    },
    uploadFile() {
      //点击添加附件
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      let arr = [];
      if (this.clientType == "android") { 
        arr.push(data);
        this.files = this.files.concat(arr);
      } else {
        let cc = JSON.parse(data);
        arr.push(cc);
        this.files = this.files.concat(arr);
      }
      this.$emit("changeFile", this.files);
    },

    Showswiper(showIndex) {
      //查看预览图片
      let magnifyList = [];
      let _this = this;
      _this.files.forEach(SelectBigImgs);
      function SelectBigImgs(item) {
        if (
          _this.getFormat(item.fileName) == "jpg" ||
          _this.getFormat(item.fileName) == "png" ||
          _this.getFormat(item.fileName) == "jpeg"
        ) {
          magnifyList.push(item.url);
        }
      }
      let data = {
        showImgs: magnifyList,
        swipercliclIndex: showIndex,
        swiperShow: true,
      };
      if (magnifyList.length > 0) {
        this.$store.commit("setDataImgs", data);
      }
    },
    //下载附件
    downLoad(data) {
      let StringJson = JSON.stringify(data);
      // let userAgent = window.navigator.userAgent.toLowerCase(); //获取UA信息
      // console.log(userAgent);
      if (this.userAgentType) {
        //在app
        //判断ua中是否含有和app端约定好的标识ezhouxing
        if (this.clientType == "android") {
          //安卓
          window.android.getInfo(105, StringJson);
        } else {
          let dataArguments = {
            url: data.url,
            fileName: data.fileName,
            twoArguments: "",
          };
          if (
            this.getFormat(data.fileName) == "jpg" ||
            this.getFormat(data.fileName) == "png" ||
            this.getFormat(data.fileName) == "jpeg"
          ) {
            dataArguments.twoArguments = "picture";
          }
          window.webkit.messageHandlers.downLoad.postMessage(
            JSON.stringify(dataArguments)
          );
        }
      } else {
        let alink = document.createElement("a");
        alink.href = data.url;
        alink.download = data.fileName; //图片名
        alink.click();
      }
    },
    preview(data) {
      //原生交互预览
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(116, JSON.stringify(data));
      } else {
        window.webkit.messageHandlers.preview.postMessage(JSON.stringify(data));
      }
    },
  },
  watch: {
    filesData: {
      handler(val) {
        if (val && val.baseAnnexes) {
          this.files = val.baseAnnexes;
          this.baseType =
            this.filesData.verifyStatus == "hold" ||
            this.filesData.verifyStatus == "deny"
              ? true
              : false;
        }
      },
      deep: true,
    },
    editType(newValue) {
      console.log(newValue);
    },
  },
};
</script>
<style lang="less">
.filePage {
  > p.fgx {
    width: 100%;
    height: 10px;
    background-color: #f6f6f6;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    border: 0 none;
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .accessoryBox {
    padding-bottom: 8px;
    > p {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #e0e0e0;
      a.recordImg {
        font-size: 14px;
        display: inline-block;
        position: absolute;
        top: 0;
        right: 12px;
        color: #3c78f9;
        font-weight: 400;
      }
    }
    > p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 21px;
      background: #2581d6;
      top: 12px;
      left: 16px;
    }
    .noneFile {
      font-size: 14px;
      padding: 0 16px;
      color: #333;
      text-align: left;
    }
    .detailMian {
      padding: 0 16px;
      width: 100%;
      margin-top: 10px;

      li {
        width: 100%;
        min-height: 40px;
        margin: 10px 0;

        dl {
          width: 85%;
          position: relative;

          dt {
            display: block;
            width: 40px;
            height: 40px;
            background-color: #f6f6f6;
            position: absolute;
            img {
              width: 100%;
              height: 100%;
            }
          }

          dd {
            display: block;
            font-size: 10px;
            color: #999;
            position: absolute;
          }

          dd.dtName {
            width: 80%;
            overflow: hidden;
            white-space: nowrap;
            /*设置内容不换行*/
            text-overflow: ellipsis;
            font-size: 12px;
            color: #666;
            top: 0px;
            left: 50px;
          }
          dd.Mb {
            top: 17px;
            left: 50px;
          }
        }
      }

      a {
        display: block;
        font-size: 12px;
        color: #35c476;
        width: 30px;
        height: 30px;
        line-height: 30px;
      }
      a.delBtn {
        color: #f34646;
      }
    }
  }
}
</style>